<template>
<div>
  <HomeLayout bg_icon="lock"  v-if="$mq === 'md'">
    <h2>Change Password</h2>
    <p></p>
    <div class="alert alert-danger" v-if="error">
      <p v-if="error" class="error">{{ error.message }}</p>
    </div>
    <form @submit.prevent="passwordChange">
      <div class="form-group">
        <input type="password" class="form-control" placeholder="Enter your old password" v-model="oldpass" required>
      </div>
      <div class="form-group">
        <input type="password" class="form-control" placeholder="Enter your new password" v-model="newpass" required>
      </div>
      <button class="btn blue">change password</button>
    </form>
    <div class="row marketing">
    </div>
  </HomeLayout>
  <MobileLayout v-if="$mq === 'sm'">
    <form @submit.prevent="confirm">
      <div class="heading-card card row">
        <div class="col s2 left-card">
            <div class="bg">
              <div class="bg-icon-wrapper">
                  <div><i class='material-icons bg-icon'>lock</i></div>
              </div>
          </div>
        </div>
        <div class="col s10">
          <h1>enter a new passowrd + <br/>you'll be goot to go</h1>
        </div>
      </div>
      <div class="alert alert-danger" v-if="error">
        <p v-if="error" class="error">{{ error.message }}</p>
      </div>
      <div class="form-card">
        <input type="password" class="form-control" placeholder="Enter your old password" v-model="oldpass" required>

        <input type="password" class="form-control" placeholder="Enter your new password" v-model="newpass" required>
      </div>
      <button class="btn blue">change password</button>
      <p class="white-text">
        we recommend using a password manager, like 1Password, to keep track of all the passwords you have
      </p>
    </form>
  </MobileLayout>
</div>
</template>

<script>
import HomeLayout from '@/containers/layouts/HomeLayout'
import MobileLayout from '@/containers/layouts/MobileLayout'

export default {
  data () {
    return {
      oldpass: '',
      newpass: '',
      error: null
    }
  },
  methods: {
    passwordChange () {
      this.$cognitoAuth.changePassword(this.oldpass, this.newpass, (err, result) => {
        if (err) {
          this.error = err
          console.error(err)
        } else {
          this.$router.replace('/settings')
        }
      })
    }
  },
  components: {
    HomeLayout, MobileLayout
  }
}
</script>

<style scoped>
.error {
  color: red;
}
.mobileLayout {
  background-image: url('./../../assets/galaxy.png');
  background-size: cover;
}
</style>



// WEBPACK FOOTER //
// src/containers/authentication/PasswordChange.vue